// extracted by mini-css-extract-plugin
module.exports = {"partners":"Partners_partners__26x8X","wrapper":"Partners_wrapper__2uNdh","partner":"Partners_partner__2_lZo","icon":"Partners_icon__GIi5F"};